import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** リース履歴処理 */
enum LeaseHistoryProcessing {
  laStartRegistration = '3',
  laCancelBeforeMaturity = '5',
  laContractInfoChange = '4',
  laArticleInfoChange = '1',
  reLeaseAndContractExpired = '6',
}

const nameConfig = {
  laArticleInfoChange: new Map([[Locale.ja, 'リース物件情報変更']]),
  laStartRegistration: new Map([[Locale.ja, 'リース開始登録']]),
  laContractInfoChange: new Map([[Locale.ja, 'リース契約情報変更']]),
  laCancelBeforeMaturity: new Map([[Locale.ja, 'リース中途解約']]),
  reLeaseAndContractExpired: new Map([[Locale.ja, '再リース及び契約満了']]),
};

const toEnum = rawValueToEnum(LeaseHistoryProcessing, LeaseHistoryProcessing.laStartRegistration);
const toDisplay = enumToName(LeaseHistoryProcessing, nameConfig);
const toDisplayWithPrefix = enumToName(LeaseHistoryProcessing, nameConfig, { prefix: true });

export const leaseHistoryProcessing = {
  enum: LeaseHistoryProcessing,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { LeaseHistoryProcessing };
